import React from 'react';
import Wrapper from 'components/packages/HeaderPackage/Wrapper';
import { transformPackagePropsToUIProps } from './transform';

const SlimLead = (props) => {
  const uiProps = transformPackagePropsToUIProps(props);
  const {
    imageUrlDesktop,
    imageUrlMobile,
    packageID,
  } = uiProps;

  return (
    <Wrapper id={packageID} className="slim-lead">
      {imageUrlDesktop && (
        <div className="slim-lead__background-image slim-lead__background--desktop" style={{ backgroundImage: `url(${imageUrlDesktop})` }} />
      )}
      {imageUrlMobile && (
        <div className="slim-lead__background-image slim-lead__background--mobile" style={{ backgroundImage: `url(${imageUrlMobile})` }} />
      )}
    </Wrapper>
  );
};

export default SlimLead;
